import { render, staticRenderFns } from "./RestrictedCaseDetails.vue?vue&type=template&id=32c759a4&"
import script from "./RestrictedCaseDetails.vue?vue&type=script&lang=ts&"
export * from "./RestrictedCaseDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports